import React from 'react';
import { Users } from '../../../../shared/assets/AppIcons';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';

export default function UsageByUserChart({ data }) {
  return (
    <Card className="border-[var(--border)]">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Users className="text-[var(--chart-accent-1)]" size={16} />
          Utilizzi per Persona
        </CardTitle>
        <CardDescription>Distribuzione team</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={45}
                outerRadius={75}
                paddingAngle={3}
                dataKey="utilizzi"
                nameKey="nome"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{ backgroundColor: 'var(--source-color-142)', border: '1px solid var(--source-color-108)', borderRadius: '8px' }}
                formatter={(value, name) => [`${value} utilizzi`, name]}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="flex flex-wrap gap-3 justify-center mt-2">
          {data.map((persona, index) => (
            <div key={index} className="flex items-center gap-1.5 text-xs">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: persona.color }} />
              <span className="text-[var(--text-secondary)]">{persona.nome}</span>
              <span className="font-semibold text-[var(--text-primary)]">({persona.utilizzi})</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
